module.exports = __webpack_public_path__ + "img/matchoption.6dd31835.svg";